export const EXPRESS_SERVER_URL = process.env.NODE_ENV !== 'production' ? "http://localhost:3001" : "/api" // /api              // http://localhost:3001
export const SOCKET_SERVER_URL = process.env.NODE_ENV !== 'production' ? "http://localhost:3001" : "/" // /
export const COOKIES_EXPIRES_TIME = 1 // one day
export const MIN_MINER_COUNT = 3
export const MAX_MINER_COUNT = 40
